import ChannelEditPriorityPage from '../ChannelEdit/ChannelEditPriorityPage'

export default ChannelEditPriorityPage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditPriorityPage.js